<template>
  <div class="color-simple" :class="{ [type]: type }" :style="{ width }">
    <div class="_title">{{ unit }}</div>
    <div class="color-simple-color" :style="backgroundImage"></div>
    <div class="color-simple-value">
      <div v-for="(item, index) in orderedData" :key="index">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unit: {
      type: String,
      default: 'm/s'
    },
    colors: {
      type: Array,
      default: () => []
    },
    values: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: () => 'vertical'
    },
    width: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    orderedData() {
      if (this.type === 'vertical') {
        const data = [...this.values];
        return data.reverse();
      }
      return this.values;
    },
    backgroundImage() {
      const indent = Math.round(100 / this.colors.length);
      const arr = this.colors.map((color, i) => `${color} ${i * indent}%`);
      const angle = this.type === 'horizontal' ? '90deg' : '0deg';
      return `background-image: linear-gradient(${angle}, ${arr.join(',')});`;
    }
  }
};
</script>

<style lang="less" scoped>
.color-simple {
  position: relative;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 8px;
  padding: 8px;
  width: 40px;
  height: 300px;

  &.vertical {
    .title {
      font-size: 8px;
      text-align: center;
    }

    .color-simple-color {
      width: 20px;
      height: 280px;
      margin-top: 4px;
    }

    .color-simple-value {
      font-size: 8px;
      position: absolute;
      width: 30px;
      top: 24px;
      bottom: 8px;
      left: 35px;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  &.horizontal {
    min-width: 300px;
    height: 40px;

    ._title {
      position: absolute;
      right: 10px;
    }

    .color-simple-color {
      margin-right: 30px;
      height: 20px;
    }

    .color-simple-value {
      width: 100%;
      position: relative;
      display: flex;

      > div {
        flex: 1;
      }
    }
  }
}
</style>
